// Pure helpers for per-window lead lists (see salesSlice `leadLists`).
// Kept dependency-free so light modules (window manager, hooks, tests) can use them
// without pulling in salesSlice's Apollo client / app entry imports.

export const LEAD_LIST_CONTEXT = { SALES: "sales", PIPELINE: "pipeline" };
export const DEFAULT_SALES_COUNTS = { total: 0, inPipeline: 0, overdue: 0, dueToday: 0 };

// "<context>:<windowId>" inside a webtop window, or just "<context>" outside one.
export const getLeadListKey = (context, windowId) =>
  windowId ? `${context}:${windowId}` : context;

export const getLeadListContext = (listKey) =>
  String(listKey).split(":")[0] === LEAD_LIST_CONTEXT.PIPELINE
    ? LEAD_LIST_CONTEXT.PIPELINE
    : LEAD_LIST_CONTEXT.SALES;

export const createLeadList = (context, leadScope) => ({
  context,
  rows: [],
  pageCount: 0,
  loaded: false,
  filters: {},
  sort: {},
  page: 1,
  selectedFilterName: {},
  leadScope: leadScope || "MY",
  filterPanelOpen: false,
  createOpen: false,
  leadFilters: {},
  counts: DEFAULT_SALES_COUNTS,
  pendingReset: false,
});

// Stable fallback for selectors before a list's first dispatch (avoids re-render loops).
const EMPTY_LEAD_LIST = Object.freeze(createLeadList(LEAD_LIST_CONTEXT.SALES));

export const selectLeadList = (salesState, listKey) =>
  salesState?.leadLists?.[listKey] || EMPTY_LEAD_LIST;

// Finds a lead by id in any open list (falls back to the legacy shared array).
export const findLeadInLists = (salesState, leadId) => {
  if (!salesState || !leadId) return undefined;
  for (const list of Object.values(salesState.leadLists || {})) {
    const lead = list.rows.find((l) => l.id === leadId);
    if (lead) return lead;
  }
  return salesState.sales?.find((l) => l.id === leadId);
};
